<script setup lang="ts">
import { computed } from 'vue';
import type { ArticleV1 } from '@ilteducation/content-registry-types';
import { configHelper } from '@ilteducation/config';

interface Props {
  article: ArticleV1;
}

const props = defineProps<Props>();

const { getAppUrl } = configHelper;
const articleUrl = computed(() => `${getAppUrl('artiklar.begreppa')}/view/${props.article.id}`);
</script>

<template>
  <a :href="articleUrl" class="article-thumbnail">
    <!-- Decorative: the headline below is the article's text label. -->
    <v-img v-if="article?.cover?.url" :src="article.cover.url" :aspect-ratio="16 / 9" cover alt=""></v-img>
    <div class="article-headline text-secondary text-h5 text-none">
      {{ article.headline }}
    </div>
    <div class="bubble">
      <v-icon size="small" icon="fa:far fa-newspaper"></v-icon>
    </div>
  </a>
</template>
<style scoped lang="scss">
@use 'sass:map';
@use '@/foundations/theme/settings';

.article-thumbnail {
  position: relative;
  display: block;
  text-decoration: none !important;
}

.article-headline {
  font-weight: 400;
  margin-top: 12px;
  font-size: 0.9375rem !important;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.bubble {
  position: absolute;
  top: -8px;
  left: -10px;
  @media #{map.get(settings.$display-breakpoints, 'lg-and-up')} {
    top: 10px;
  }
  background-color: #f7bbc8; // trovy primary-container
  display: inline-block;
  border-radius: 100%;
  font-size: 0.75rem;
  line-height: 1.25rem;
  height: 1.75rem;
  width: 1.75rem;
  padding: 0.25rem 0.1875rem;
  text-align: center;
  text-transform: capitalize;

  i {
    color: #281519 !important; // trovy on-primary-container
  }

  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    font-weight: 500;
    line-height: 1.375rem;
    height: 2rem;
    width: 2rem;
    padding: 0.3125rem 0.1875rem;
  }
}
</style>
